import React from 'react';
import {
  FREQUENTLY_ASKED_QUESTIONS,
  FrequentlyAskedQuestions,
} from '../components/FrequentlyAskedQuestions';
import { MarketingHead } from '../components/marketing/MarketingHead';

const FAQ_HEAD = {
  title: 'Preguntas frecuentes | Áncora Automations',
  description: 'Respuestas sobre WhatsApp, conexiones, permisos, citas, tareas disponibles y decisiones que Áncora debe pasar al equipo.',
  imagePath: '/og-image.png',
  imageAlt: 'Preguntas frecuentes de Áncora Automations',
  schema: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: 'Preguntas frecuentes',
    url: 'https://www.ancoraautomations.es/preguntas-frecuentes',
    mainEntity: FREQUENTLY_ASKED_QUESTIONS.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  },
} as const;

export const FrequentlyAskedQuestionsPage: React.FC = () => (
  <div className="marketing-shell" data-surface="frequently-asked-questions-page">
    <MarketingHead path="/preguntas-frecuentes" {...FAQ_HEAD} />
    <FrequentlyAskedQuestions />
  </div>
);
